/* template */
<template minapp="mpx" xlang="wxml"><div class="wrapper" v-if="(number)"><div class="offline-refund"><div class="offline-refund-text"><div class="offline-refund-text-num">温馨提示：</div>当前订单{{number}}笔线下退款，需尽快确认</div><mpx-view @tap="toOfflineRefundDetailPage" class="offline-refund-arrow">退款确认<mpx-image src="https://ut-static.udache.com/webx/sfc/SurrbhwdBTSNdfKCJ6aCW.png" class="icon"/></mpx-view></div></div></template>

/* styles */
<style scoped lang="stylus" mpxStyleOptions='{"mid":"mdcef8d9a"}'>
@import '~@/mixins/stylus/color.styl'

.wrapper
  margin 0 -12px
  background-color #fff
  padding 12px
  padding-top 0
.offline-refund
  display flex
  align-items center
  justify-content space-between
  border-radius 6px
  box-sizing border-box
  padding 10px
  font-size 12px
  font-family PingFangSC-Medium;
  background-color #FFF0EE
  &-icon
    width 20px
    height 20px
    margin-right 4px
    background-repeat no-repeat
    background-size 100%
    background-position center
    background-image url('https://img-hxy021.didistatic.com/static/starimg/img/XApIU4jPEH1686801129710.png')
  &-text
    display flex
    align-items center
    flex 1
    color #3D3D3D
    font-family PingFangSC-Medium
    &-num
      color #FF4129
  &-arrow
    height 100%
    font-family PingFangSC-Medium
    flex none
    display flex
    color #FF4129
    align-items center
	.icon 
	  height 12px
	  width 12px
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentModuleId = "mdcef8d9a"
  global.currentSrcMode = "wx"
  /** script content **/
  require("./offline-refund.mpx.js?isComponent&outputPath=components%2Foffline-refunddcef8d9a%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./offline-refund.mpx?ctorType=component&index=0&isComponent&mpx&outputPath=components%2Foffline-refunddcef8d9a%2Findex&type=script")
  const currentOption = global.__mpxOptionsMap["mdcef8d9a"]
  export default processOption(
    currentOption,
    "component",
    "",
    "components/offline-refunddcef8d9a/index",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {'mpx-view':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-view.vue?isComponent"), { __mpxBuiltIn: true }),'mpx-image':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-image.vue?isComponent"), { __mpxBuiltIn: true })},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
